import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import MapsLayer from "../components/MapsLayer";

const MapsPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title="Venue Map" />

        {/* MapsLayer */}
        <MapsLayer />
      </MasterLayout>
    </>
  );
};

export default MapsPage;
